import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, "Decide reimbursement request", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-row items-center justify-between border border-primary rounded-2xl p-4 mb-4" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { class: "flex-col w-60" }
const _hoisted_12 = { class: "flex flex-row items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Amount:", -1)
const _hoisted_14 = { class: "uppercase" }
const _hoisted_15 = { class: "flex flex-row items-center justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Fees & taxes:", -1)
const _hoisted_17 = { class: "uppercase" }
const _hoisted_18 = { class: "flex flex-row items-center justify-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_20 = { class: "uppercase" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col bg-gray-100 rounded p-4 mb-4"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Reason", -1)
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Please select one of the following options to decide")
], -1)
const _hoisted_25 = { class: "flex flex-row mb-4" }
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Deny reimbursement", -1)
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Approve reimbursement", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-300 w-full my-6" }, null, -1)
const _hoisted_33 = { class: "flex flex-row justify-between items-center" }
const _hoisted_34 = { class: "flex flex-row items-center" }
const _hoisted_35 = {
  key: 0,
  class: "flex flex-col mr-4"
}
const _hoisted_36 = { class: "text-gray-500 text-sm" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openDecision)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_UserCard, {
                    firstName: _ctx.reimbursement.user.first_name,
                    lastName: _ctx.reimbursement.user.last_name,
                    position: _ctx.reimbursement.user.job?.title
                  }, null, 8, ["firstName", "lastName", "position"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.reimbursement.detail.replaceAll("_", " ")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, " $" + _toDisplayString((_ctx.reimbursement.original_amount / 100).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, " $" + _toDisplayString((_ctx.reimbursement.original_fee / 100).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, " $" + _toDisplayString((_ctx.reimbursement.original_total / 100).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ])
                  ])
                ]),
                (_ctx.reimbursement.note)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.reimbursement.note), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downvote && _ctx.downvote(...args))),
                    class: _normalizeClass(`rounded p-4 bg-${_ctx.downvoteBtn.color} text-${_ctx.downvoteBtn.text}`)
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        src: require(`@/assets/icons/${_ctx.downvoteBtn.img}.svg`)
                      }, null, 8, _hoisted_27),
                      _hoisted_28
                    ])
                  ], 2),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.upvote && _ctx.upvote(...args))),
                    class: _normalizeClass(`rounded p-4 bg-${_ctx.upvoteBtn.color} text-${_ctx.upvoteBtn.text}`)
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("img", {
                        src: require(`@/assets/icons/${_ctx.upvoteBtn.img}.svg`)
                      }, null, 8, _hoisted_30),
                      _hoisted_31
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.downvoteBtn.selected)
                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 0,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                        placeholder: "Write a reason *",
                        rows: "4",
                        class: "w-full rounded bg-background p-4 resize-none focus:outline-none"
                      }, null, 512)), [
                        [_vModelText, _ctx.message]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn-outline-sm"
                }, "Cancel"),
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.upvoteBtn.selected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, " Will be included in the " + _toDisplayString(_ctx.nextUnlockedPayroll?.status || "upcoming") + " payroll ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.decide && _ctx.decide(...args))),
                    disabled: !_ctx.isSelected,
                    class: _normalizeClass(["disabeld:cursor-not-allowed disabled:opacity-50", {
                  'btn-filled-lg': !_ctx.loading,
                  'btn-filled-lg-loading': _ctx.loading,
                }])
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Send decision"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, "Loading..."))
                  ], 10, _hoisted_37)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openDecision)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40))
      : _createCommentVNode("", true)
  ]))
}